import { render } from "./ResultsSummary.vue?vue&type=template&id=5da8ae8e&scoped=true"
import script from "./ResultsSummary.vue?vue&type=script&lang=js"
export * from "./ResultsSummary.vue?vue&type=script&lang=js"

import "./ResultsSummary.vue?vue&type=style&index=0&id=5da8ae8e&scoped=true&lang=css"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da8ae8e"]])

export default __exports__